"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType["DEVICE_REFRESH_TOKEN"] = "deviceRefreshToken";
    TokenType["APPLICATION_ACCESS_TOKEN"] = "applicationAccessToken";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
